import { render, staticRenderFns } from "./GenericDisplay.vue?vue&type=template&id=b053328e&scoped=true&"
import script from "./GenericDisplay.vue?vue&type=script&lang=js&"
export * from "./GenericDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GenericDisplay.vue?vue&type=style&index=0&id=b053328e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b053328e",
  null
  
)

export default component.exports